module.exports = __webpack_public_path__ + "img/couples-004.04f2f327.jpg";